module.exports = __webpack_public_path__ + "pic_bizny_web_06@1x.png?ac1bd004dfd1debd3b03e2b6a3323fbe";